import React from 'react';
import UserRegular from 'jl-ui-kit/elements/icons/UserRegular';
import styles from './account-button.scss';

export const AccountButton = ({ onClick, greeting }) => (
  <a
    href="/my-account"
    onClick={onClick}
    data-test="account-button"
    className={styles.container}
  >
    {greeting && <span className={styles.greeting}>{greeting}</span>}
    <UserRegular box />
    <span className={styles.label}>Account</span>
  </a>
);

export default AccountButton;
